import React, { useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { fetchDefault } from '../Utils.js';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    margin: {
        marginTop: 50,
    },
}));


export default function Complete(props) {

    const classes = useStyles();
    let history = useHistory();
    const [completeOpen, setCompleteOpen] = React.useState(false);
    const closeCompleteDialog = useRef();

    const query = new URLSearchParams(props.location.search);
    
    const totalPrice = query.get('totalPrice');
    const controllerUrl = query.get('url');
    const merchantUid = query.get('merchant_uid');
    const success = query.get('imp_success');

    useEffect(() => {

        if (success) {
            fetchDefault('Payment/ChargePointFromWeb?merchantUid=' + merchantUid + '&point=' + totalPrice,
                (data) => {
                    fetchDefault(controllerUrl + '&payment=0',
                        (data) => {
                            setCompleteOpen(true);
                            closeCompleteDialog.current = setTimeout(moveToHome, 5000);
                        }
                    );
                }
            );
        } else {
            alert('결제 실패');
        }

    }, []);

    const moveToHome = () => {
        setCompleteOpen(false);
        history.push('/');
    };

    return (
        <div>
            <Dialog
                open={completeOpen}
                onClose={moveToHome}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <Typography variant="h6" color="textPrimary">
                        결제가 완료되었습니다!
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={moveToHome}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/payment/Complete.js